import {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {BreadCrumbs} from "../../../components/open/pages";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

export const HomeReportViewScreen = () => {
    const {reportNd} = useParams();
    const [data, setData] = useState({
        loaded: false,
        title: '',
        body: '',
        createdAt: '2000-01-01 00:00:00',
        teacher: '',
        avatar: '',
        course: '',
        class: '',
        img: '',
        images:[] as string[],
    });
    const navigate = useNavigate();
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/home/reports/get',
            {
                nd: reportNd,
            },
            false,
            (d: {
                result: string,
                reason: string,
                title: string,
                body: string,
                createdAt: string,
                teacher: string,
                avatar: string,
                course: string,
                class: string,
                img: string,
                images: string[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'not-found') {
                        navigate('/science-center', {replace: true});
                        ShowSnackbar(
                            'یافت نشد.',
                            'باشه',
                            5000,
                        );
                    }
                    return;
                }
                document.title = d.title + " | گزارشات کلاسی | شهاب مدرسه زندگی";
                let lst = [
                    {src: ServerImage(d.img)},
                ];
                if (d.images !== null)
                    d.images.forEach(e => {
                        lst.push({src: ServerImage(e)});
                    });
                setImages(lst);
                setData({
                    loaded: true,
                    images: d.images === null ? [] : d.images,
                    body: d.body,
                    avatar: d.avatar,
                    title: d.title,
                    class: d.class,
                    course: d.course,
                    img: d.img,
                    createdAt: d.createdAt,
                    teacher: d.teacher,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [images, setImages] = useState<{ src: string }[]>([]);
    const [lightBox, setLightBox] = useState({
        show: false,
        index: 0,
    });
    const slideshowRef = useRef(null);
    const zoomRef = useRef(null);
    return (
        <>
            <div style={{background: '#fff'}}>
                <div className="container-big">
                    <BreadCrumbs links={[
                        {title: 'گزارشات کلاسی شهاب', url: '/reports'},
                        {title: data.loaded ? data.title : '...', url: `/reports/view/${reportNd}`},
                    ]}/>
                </div>
                <div className="home-news-view">
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-7">
                                <h1>{data.title}</h1>
                                <div className="home-news-view-author">
                                    <strong style={{backgroundImage: `url(${ServerImage(data.avatar, 200)})`}}/>
                                    <div>
                                        <b>{data.teacher}</b>
                                        <span>دبیر مدرسه شهاب</span>
                                    </div>
                                </div>
                                <i>کلاس {data.class}</i>
                                <i>درس {data.course}</i>
                                <div style={{height: 7}}/>
                                <p>{data.body}</p>
                                <em>{StringDigitsConvertToPersian(GregorianToPersian(data.createdAt.split(' ')[0]).replaceAll('-', '/'))}</em>
                            </div>
                            <div className="col-lg-5">
                                <div className="course-report-images row">
                                    <div className="col-12">
                                        <button
                                            style={{backgroundImage: `url(${ServerImage(data.img, 500)})`}}
                                            onClick={() => setLightBox({
                                                index: 0,
                                                show: true,
                                            })}
                                        />
                                    </div>
                                    {
                                        data.images.map((d, i) =>
                                            <div className="col-6" key={"J28SSj_uSisXj8xX" + i}>
                                                <button
                                                    style={{backgroundImage: `url(${ServerImage(d, 500)})`}}
                                                    onClick={() => setLightBox({
                                                        index: i + 1,
                                                        show: true,
                                                    })}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Lightbox
                plugins={[Fullscreen, Slideshow, Zoom]}
                zoom={{ref: zoomRef}}
                // @ts-ignore
                slideshow={{ref: slideshowRef}}
                open={lightBox.show}
                index={lightBox.index}
                close={() => setLightBox({
                    index: 0,
                    show: false,
                })}
                slides={images}
                className={"ltr"}
            />
        </>
    );
};